import domReady from "@wordpress/dom-ready";

document.addEventListener('DOMContentLoaded', function () {
    const termBlocks = document.querySelectorAll('[data-term-id]');

    termBlocks.forEach((termBlock) => {
        const termId = termBlock.getAttribute('data-term-id');
        const nestedBlock = termBlock.querySelector('.wp-block-celebrate-suite-celebrate-term-image');

        if (nestedBlock) {
            const blockId = nestedBlock.getAttribute('data-block');
            if (blockId) {
                wp.data.dispatch('core/block-editor').updateBlockAttributes(blockId, { termID: termId });
            }
        }
    });
});

domReady(() => {

    function updateChicklets() {
        const containers = document.querySelectorAll('nav.wp-block-celebrate-suite-celebrate-taxonomy-display-terms ul.celebrate-menu-taxonomy-terms');
        containers.forEach(container => {
            const blockGap = parseInt(container.dataset.blockgap.replace('px', '')) || 20;
            const moreText = container.dataset.moretext;
            const overflowDisplay = container.dataset.overflowdisplay;
            const overflowLink = container.dataset.overflowlink;
            const menuLinkDisplay = container.dataset.menulinkdisplay;
            const buttonBgColor = container.dataset.buttoncolor;
            const dropdownBgColor = container.dataset.dropdowncolor;

            let containerWidth = container.offsetWidth - 180;
            let totalWidth = 0;
            let chicklets = Array.from(container.querySelectorAll('.chicklet'));
            let numChickletsToShow = 0;

            // Clear previous dynamic elements
            container.querySelectorAll('.dropdown, .more-button').forEach(el => el.remove());
            chicklets.forEach(chicklet => chicklet.style.display = '');

            chicklets.forEach(chicklet => {
                totalWidth += chicklet.offsetWidth + blockGap;
                if (totalWidth > containerWidth) {
                    return false;
                }
                numChickletsToShow++;
            });

            if (numChickletsToShow < chicklets.length) {
                if (overflowDisplay === 'dropdown') {
                    let dropdownContainer = document.createElement('div');
                    dropdownContainer.className = `dropdown display-as-${menuLinkDisplay}`;
                    let spanElement = document.createElement('span');
                    spanElement.textContent = moreText;
                    spanElement.style.backgroundColor = buttonBgColor;
                    dropdownContainer.appendChild(spanElement);
                    let dropdownInner = document.createElement('div');
                    dropdownInner.className = 'dropdown-inner';
                    dropdownInner.style.backgroundColor = dropdownBgColor;
                    dropdownInner.style.border = `1px solid ${dropdownBgColor}`;
                    dropdownContainer.appendChild(dropdownInner);

                    chicklets.slice(numChickletsToShow).forEach(chicklet => {
                        chicklet.style.display = 'none';
                        let listItem = document.createElement('li');
                        listItem.innerHTML = `<a style="background-color: unset;" href="${chicklet.querySelector('a').href}">${chicklet.textContent}</a>`;
                        dropdownInner.appendChild(listItem);
                    });
                    container.appendChild(dropdownContainer);
                } else if (overflowDisplay === 'button') {
                    // Hide overflow chicklets regardless of whether link exists
                    chicklets.slice(numChickletsToShow).forEach(chicklet => chicklet.style.display = 'none');
                    
                    // Only create button if link exists
                    if (overflowLink) {
                        let moreButtonLi = document.createElement('li');
                        moreButtonLi.className = 'chicklet';
                        let moreButton = document.createElement('a');
                        moreButton.href = overflowLink;
                        moreButton.textContent = moreText;
                        moreButton.className = `more-button display-as-${menuLinkDisplay}`;
                        moreButton.style.backgroundColor = buttonBgColor;
                        moreButtonLi.appendChild(moreButton);
                        container.appendChild(moreButtonLi);
                    }
                }
            }
            container.style.opacity = '1';
        });
    }

    updateChicklets();
    window.addEventListener('resize', updateChicklets);

    const galleries = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-taxonomy-display-terms .celebrate-display-terms-slideshow");

    galleries.forEach((gallery) => {
        const parent = gallery.closest('.wp-block-celebrate-suite-celebrate-taxonomy-display-terms');
        if (parent) {
            const navigation = parent.getAttribute('data-navigation') === 'true';
            const pagination = parent.getAttribute('data-pagination') === 'true';
            const autoplay = parent.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parent.getAttribute('data-autoplay-speed')) || 4000;
            const groupCells = parent.getAttribute('data-group-cells') === 'true';
            const centerMode = parent.getAttribute('data-center-mode') === 'true';

            const flkty = new Flickity(gallery, {
                cellAlign: centerMode ? "center" : "left",
                contain: true,
                draggable: true,
                wrapAround: true,
                percentPosition: false,
                imagesLoaded: true,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false,
                groupCells: groupCells,
                on: {
                    ready: function () {
                        gallery.style.opacity = 1;
                    }
                }
            });

        }
    });
});